import React from 'react';
import { IMainMenuProps, MainMenu } from '../MainMenu';

export const mainMenuViewKey = 'mainMenu';

export const MainMenuView: React.FunctionComponent<IMainMenuProps> = props => {
    return (
        <MainMenu
            onShowCredits={props.onShowCredits}
            onShowSettings={props.onShowSettings}
            onShowLevelSelection={props.onShowLevelSelection}
        />
    );
};
